module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_vm._v("Books by Penelope Lively")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('i', [_vm._v("fiction")])])]), _vm._v(" "), _c('p', {
    staticClass: "halfline"
  }), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("THE ROAD TO LICHFIELD")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("NOTHING MISSING BUT THE SAMOVAR")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("TREASURES OF TIME")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("JUDGEMENT DAY")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("NEXT TO NATURE, ART")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("PERFECT HAPPINESS")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("CORRUPTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("ACCORDING TO MARK")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("PACK OF CARDS")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("MOON TIGER")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('i', [_vm._v("for children")])])]), _vm._v(" "), _c('p', {
    staticClass: "halfline"
  }), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("ASTERCOTE")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("THE WHISPERING KNIGHTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("THE WILD HUNT OF HAGWORTHY")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("THE DRIFTWAY")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("THE GHOST OF THOMAS KEMPE")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("THE HOUSE IN NORHAM GARDENS")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("GOING BACK")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("BOY WITHOUT A NAME")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("THE STAINED GLASS WINDOW")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("A STITCH IN TIME")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("FANNY'S SISTER")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("THE VOYAGE OF QV66")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("FANNY AND THE MONSTERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("FANNY AND THE BATTLE OF POTTER'S PIECE")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("THE REVENGE OF SAMUEL STOKES")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("UNINVITED GHOSTS AND OTHER STORIES")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("DRAGON TROUBLE")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("A HOUSE INSIDE OUT")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('i', [_vm._v("nonfiction")])])]), _vm._v(" "), _c('p', {
    staticClass: "halfline"
  }), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("THE PRESENCE OF THE PAST:")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("AN INTRODUCTION TO LANDSCAPE HISTORY")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a384daa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/002_Books_By.vue
// module id = 60
// module chunks = 0